import axios from 'axios';
import { config } from '../../Configs';

export const GetRequestAPI = async (token, requestId, params = null) => {
  const configObject = {
    headers: {
      Authorization: token
    }
  };

  if (params) {
    configObject.params = params;
  }

  try {
    const response = await axios.get(
      `${config.api.url}/requests/${requestId}`,
      configObject
    );
    return { success: true, data: response };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetRequestsAPI = async (token, params) => {
  try {
    const response = await axios.get(`${config.api.url}/requests`, {
      headers: {
        Authorization: token
      },
      params
    });
    return { success: true, data: response };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const ApproveRequestAPI = async (token, requestId) => {
  try {
    const response = await axios.put(
      `${config.api.url}/requests/${requestId}/approve`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    );
    return { success: true, data: response };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const RejectRequestAPI = async (token, requestId, data) => {
  try {
    const response = await axios.put(
      `${config.api.url}/requests/${requestId}/reject`,
      data,
      {
        headers: {
          Authorization: token
        }
      }
    );
    return { success: true, data: response };
  } catch (err) {
    return { success: false, error: err };
  }
};
